import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { Type } from "class-transformer";
import { InterventionDto } from "@/core/features/interventions/intervention.dto";
import { ClientGroupDto } from "@/core/features/client-groups/client-group.dto";
import { ReportSectionDto } from "@/core/features/report-sections/report-section.dto";
import { TemplateDto } from "@/core/features/templates/template.dto";
import { UserDto } from "../users/user.dto";

export class ReportTemplateDto extends BaseEntityDto {
  name: string;
  active: boolean;

  @Type(() => InterventionDto)
  intervention: InterventionDto;
  interventionId: string;

  @Type(() => ClientGroupDto)
  clientGroup: ClientGroupDto;
  clientGroupId: string;

  @Type(() => ReportSectionDto)
  reportSections: ReportSectionDto[];

  @Type(() => TemplateDto)
  template?: TemplateDto;
  templateId?: string;

  @Type(() => UserDto)
  updatedBy: UserDto;
}
